import React from "react";
import AuditTrail from "../../../components/AuditTrail";
import { ApiURL } from "../../../services/apiConstants";

export default function AuditPage() {
  return <AuditTrail endpoint={ApiURL.daily_task_log_audit_logs_st} />;
}
